// import React, { useEffect, useState } from "react";
// import { Card, CardContent, Typography, CircularProgress, Grid, Box } from "@mui/material";
// import { getDecryptedAccessToken } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
// import ApiServices from "../../../Utils/ApiServices/ApiServices";
// import Loader from "../../../Container/Loader/Loader";
// import WelComeHeader from "../../PatientComponents/PatientDashboard/WelComeHeader";
// import BookAppointment from "../../PatientComponents/BookAppointment/BookAppointment";
// import AllAppointments from "../../PatientComponents/BookAppointment/AllAppointments";
// import PatientAllergies from "../../PatientComponents/PatientDashboard/PatientAllergies";
// import PatientLabReports from "../../PatientComponents/PatientDashboard/PatientLabReports";
// import PatientDocuments from "../../PatientComponents/PatientDashboard/PatientDocuments";

// const PatientDetails = ({ uuid }) => {
//   const [patientData, setPatientData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const accessToken = getDecryptedAccessToken();
  
//   useEffect(() => {
//     const fetchPatientDetails = async () => {
//       try {
//         const response = await ApiServices.get(`/apis/default/api/patient/${uuid}`, {
//            Authorization: `Bearer ${accessToken}` ,
//         });
//         console.log("responseresponse",response)
//         if (response) {
//           const {fname,lname,DOB,street,city,state,email,phone_contact,sex,is_medical_history_intake,is_financial_disclosure,is_hippa_form,pid,uuid} = response.data.data;
//           setPatientData({fname,lname,DOB,street,city,state,email,phone_contact,sex,is_medical_history_intake,is_financial_disclosure,is_hippa_form,pid,uuid});
//         } else {
//           throw new Error("Failed to fetch patient details");
//         }
//       } catch (err) {
//         setError(err.message || "Something went wrong");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPatientDetails();
//   }, [uuid, accessToken]);

//   if (loading) return <Loader />;
//   if (error) return <Typography color="error">{error}</Typography>;

//   return (
//     <div>
//     <Box>
//     <WelComeHeader patientData={patientData}/>
//     <AllAppointments patientData={patientData}/>
//       <Grid container spacing={2} sx={{ mt: 2 }}>
//         <Grid item xs={12} md={4}>
//           <PatientDocuments patientData={patientData}/>
//         </Grid>
//         <Grid item xs={12} md={4}>
//           <PatientLabReports patientData={patientData}/>
//         </Grid>
//         <Grid item xs={12} md={4}>
//           <PatientAllergies patientData={patientData}/>
//         </Grid>
//       </Grid>
//         <BookAppointment patientData={patientData}/>
//     </Box>
//     </div>
//   );
// };

// export default PatientDetails;




import React, { useEffect, useState } from "react";
import { Typography, Grid, Box } from "@mui/material";
import { getDecryptedAccessToken } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
import ApiServices from "../../../Utils/ApiServices/ApiServices";
import Loader from "../../../Container/Loader/Loader";
import WelComeHeader from "../../PatientComponents/PatientDashboard/WelComeHeader";
import BookAppointment from "../../PatientComponents/BookAppointment/BookAppointment";
import AllAppointments from "../../PatientComponents/BookAppointment/AllAppointments";
import PatientAllergies from "../../PatientComponents/PatientDashboard/PatientAllergies";
import PatientLabReports from "../../PatientComponents/PatientDashboard/PatientLabReports";
import PatientDocuments from "../../PatientComponents/PatientDashboard/PatientDocuments";
import CryptoJS from "crypto-js";
import { useParams } from "react-router-dom";
import PatientMembership from "../../PatientMembership/PatientMembership";

const STORAGE_KEY = "patientTabsData";
const SECRET_KEY = process.env.REACT_APP_USER_ENC_DEC_KEY;

const decryptData = (encryptedData) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.error("Error decrypting data:", error);
    return null;
  }
};

const PatientDetails = () => {
  const [patientData, setPatientData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const accessToken = getDecryptedAccessToken();
  const params = useParams()
  useEffect(()=>{

    const fetchPatientDetails = async () => {
      try {
        const response = await ApiServices.get(`/apis/default/api/patient/${params.uuid}`, {
          
            Authorization: `Bearer ${accessToken}`,
          
        });
        
        if (response && response.data && response.data.data) {
          const {
            fname,
            lname,
            DOB,
            street,
            city,
            state,
            email,
            phone_contact,
            sex,
            is_medical_history_intake,
            is_financial_disclosure,
            is_hippa_form,
            pid,
            uuid,
          } = response.data.data;
          
          setPatientData({
            fname,
            lname,
            DOB,
            street,
            city,
            state,
            email,
            phone_contact,
            sex,
            is_medical_history_intake,
            is_financial_disclosure,
            is_hippa_form,
            pid,
            uuid,
          });
        } else {
          throw new Error("Failed to fetch patient details");
        }
      } catch (err) {
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };
    fetchPatientDetails()
  },[params.uuid])

  // useEffect(() => {
  //   let timeoutId = setTimeout(() => {
  //     const storedData = sessionStorage.getItem(STORAGE_KEY);
  //     let currentUuid = null;
  
  //     if (storedData) {
  //       const decryptedData = decryptData(storedData);
  //       if (decryptedData && decryptedData.tabs.length > 0) {
  //         const selectedTabIndex = decryptedData.lastTab - 2; 
  //         if (selectedTabIndex >= 0 && decryptedData.tabs[selectedTabIndex]) {
  //           currentUuid = decryptedData.tabs[selectedTabIndex].uuid;
  //         }
  //       }
  //       console.log("decryptedDatadecryptedData",decryptedData)
  //     }
  //     if (!currentUuid) {
  //       setError("No patient selected.");
  //       setLoading(false);
  //       return;
  //     }
  //     fetchPatientDetails(currentUuid);
  //   }, 200); 
  
  //   return () => clearTimeout(timeoutId); 
  // }, [accessToken]);

  if (loading) return <Loader />;
  if (error) return <Typography color="error">{error}</Typography>;

  return (
    <Box>
      <WelComeHeader patientData={patientData} />
      <AllAppointments patientData={patientData} />
      <Grid container spacing={2} sx={{ mt: 2 }}>
      <Grid item xs={12} md={4}>
          <PatientAllergies patientData={patientData} />
        </Grid>
        <Grid item xs={12} md={4}>
          <PatientLabReports patientData={patientData} />
        </Grid>
        <Grid item xs={12} md={4}>
          <PatientDocuments patientData={patientData} />
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ mt: 2 }}>
      <Grid item xs={12} md={4}>
          <PatientMembership patientData={patientData} />
        </Grid>
        <Grid item xs={12} md={4}>
          {/* <PatientLabReports patientData={patientData} /> */}
        </Grid>
        <Grid item xs={12} md={4}>
          {/* <PatientDocuments patientData={patientData} /> */}
        </Grid>
      </Grid>
      <BookAppointment patientData={patientData} />
    </Box>
  );
};

export default PatientDetails;
